import type {ReactNode} from 'react'

const MAX_CARACTERES = 30

export function corto(texto: string, limite = MAX_CARACTERES) {
  const limpio = texto.split(/\s+/).join(' ').trim()
  return limpio.length <= limite ? limpio : `${limpio.slice(0, limite - 1).trimEnd()}…`
}

export function LienzoSvg({
  testId,
  ariaLabel,
  ancho,
  alto,
  anchoMinimo,
  children,
}: {
  testId: string
  ariaLabel: string
  ancho: number
  alto: number
  anchoMinimo: number
  children: ReactNode
}) {
  return (
    <div className="overflow-x-auto" data-testid={testId}>
      <svg
        viewBox={`0 0 ${ancho} ${alto}`}
        role="img"
        aria-label={ariaLabel}
        className="h-auto w-full"
        style={{minWidth: `${anchoMinimo}px`}}>
        {children}
      </svg>
    </div>
  )
}
